import { NodeViewRendererProps, NodeViewWrapper } from '@tiptap/react';
import { Avatar, HoverCard } from 'ui/components';

export default function MentionUserCard(
  props:
    | NodeViewRendererProps
    | {
      node: {
        attrs: Record<string, any>;
      };
    }
) {
  const user = props.node.attrs;

  return (
    <NodeViewWrapper as="span">
      <HoverCard>
        <HoverCard.Trigger asChild>
          <span
            node-type="user"
            data-user-id={user.user_id}
            data-type={user.type}
            data-email={user.email}
            data-avatar={user.avatar}
            className="mention w-fit text-tertiary"
          >
            @{user.label}
          </span>
        </HoverCard.Trigger>
        <HoverCard.Content
          className="min-w-fit w-fit max-w-64 not-prose p-2" align="start">
          <div className="flex grow items-center gap-2">
            <Avatar
              src={user?.avatar}
              title={user.label}
              size="md"
              id={user.value}
              borderRadius="md"
            />
            <div className="flex w-full flex-col overflow-hidden text-left">
              <div className="truncate text-sm font-medium">{user?.label}</div>
              <div className="truncate text-xs text-gray-500">
                {user?.email}
              </div>
            </div>
          </div>
        </HoverCard.Content>
      </HoverCard>
    </NodeViewWrapper>
  );
}
